export default __webpack_public_path__ + "static/media/pc.298f75ca.jpeg";